<template>
  <a-drawer
    placement="right"
    width="500"
    :closable="false"
    @close="onClose"
    :visible="visible"
  >
    <div slot="title">
      <span>查看角色</span>
      <a-button v-if="!editDivVisible" style="float: right" type="primary" @click="openEditDiv">编辑</a-button>
      <a-button v-if="editDivVisible" style="float: right" type="primary" @click="openRolePermission">权限设置</a-button>
    </div>
    <div v-if="loading" style="text-align:center"><a-spin/></div>
    <div style="margin-left:30px" v-if="!loading && !editDivVisible">
      <detail-list size="small" :col="1">
        <detail-list-item term="角色名称">{{ viewDetailDate.role_name }}</detail-list-item>
        <detail-list-item term="状态">{{ viewDetailDate.role_status | valInDict(statusDict) }}</detail-list-item>
        <detail-list-item term="创建时间">{{ viewDetailDate.create_time }}</detail-list-item>
        <detail-list-item term="备注">{{ viewDetailDate.role_desc }}</detail-list-item>
      </detail-list>
      <a-divider v-if="adminList.length > 0" style="margin: 16px 0" />
      <detail-list v-if="adminList.length > 0" title="关联管理员" size="small" :col="2">
        <div v-for="item in adminList" :key="item.account">
          <detail-list-item term="管理员账号">{{ item.account }}</detail-list-item>
          <detail-list-item term="管理员昵称">{{ item.nickname }}</detail-list-item>
        </div>
      </detail-list>
    </div>
    <!-- 编辑div -->
    <editDiv
      v-if="editDivVisible"
      :visible="editDivVisible"
      :roleId="id"
      :roleDetail="viewDetailDate"
      @hide="cancelEditDiv"
      @finish="finishEdit"/>
    <!-- 权限设置抽屉 -->
    <rolePermission
      v-if="rolePermissionVisible"
      :visible="rolePermissionVisible"
      :roleId="id"
      :defalutPermissionArr="defalutPermissionArr"
      @hide="handelRolePermission"
      @finish="finish">
    </rolePermission>
  </a-drawer>
</template>
<script>
import { getRoleDetail } from '@/api/role'
import _ from 'lodash'
import editDiv from './editDiv'
import rolePermission from './rolePermission'
import DetailList from '@/components/DescriptionList'

const DetailListItem = DetailList.Item
export default {
  components: {
    DetailListItem,
    DetailList,
    editDiv,
    rolePermission
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      defailt: false
    }
  },
  data () {
    return {
      // 抽屉加载
      loading: true,
      // 编辑div状态开关
      editDivVisible: false,
      // 基本信息
      viewDetailDate: {},
      // 关联用户
      adminList: [],
      // 创建人
      createNameDate: '',
      // 权限数组
      permissionArr: [],
      // 默认选择权限数组
      defalutPermissionArr: [],
      // 权限设置抽屉状态开关
      rolePermissionVisible: false,
      statusDict: [
        { id: 'NORMAL', name: '正常' },
        { id: 'FORBIDDEN', name: '禁用' }
      ]
    }
  },
  methods: {
    // 权限设置完成相应事件
    finish () {
      this.rolePermissionVisible = false
      this.getDetail()
      this.$emit('finish')
    },
    // 打开权限设置抽屉
    openRolePermission () {
      this.rolePermissionVisible = true
    },
    // 关闭权限设置抽屉
    handelRolePermission () {
      this.rolePermissionVisible = false
    },
    // 关闭抽屉
    onClose () {
      this.$emit('hide')
    },
    // 完成编辑
    finishEdit () {
      this.editDivVisible = false
      this.getDetail()
      this.$emit('finish')
    },
    // 切换编辑div
    openEditDiv () {
      this.editDivVisible = true
    },
    // 关闭编辑div
    cancelEditDiv () {
      this.editDivVisible = false
    },
    // 加载数据详情
    getDetail () {
      this.loading = true
      this.defalutPermissionArr = []
      getRoleDetail(this.id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.viewDetailDate = _.get(res, 'data', {})
          this.adminList = _.get(res, 'values.admin_list')
          this.defalutPermissionArr = this.viewDetailDate.role_auth.split(',')
          for (const i in this.defalutPermissionArr) {
            this.defalutPermissionArr[i] = parseInt(this.defalutPermissionArr[i])
          }
          this.loading = false
        }
      })
    }
  },
  created () {
    if (this.edit === true) {
      this.editDivVisible = true
    } else {
      this.editDivVisible = false
    }
    this.getDetail()
  }
}
</script>
